export enum IntegrationType {
  GOOGLE = 'google',
  GOOGLE_APP = 'google-app',
  MICROSOFT = 'microsoft',
  MICROSOFT_APP = 'microsoft-app',
  ZOOM = 'zoom',
  SLACK = 'slack',
  MICROSOFT_TEAMS = 'microsoft-teams',
  FRESHWATER = 'freshwater',
  TACTIC_WIFI = 'tactic-wifi',
  TACTIC_MOBILE = 'tactic-mobile'
}
